import PropTypes from 'prop-types'

import { ReactComponent as DoneIcon } from './done.svg'
import styles from './FormGroup.module.scss'

const FormGroup = ({ children, title, disabled, done, contentPadding = '20px 25px' }) => (
  <div className={styles.container}>
    <p className={styles.title}>
      {done && <DoneIcon title="done icon" />}
      {title}
    </p>
    <div
      className={disabled ? styles.contentDisabled : styles.content}
      style={{ padding: contentPadding }}
    >
      {children}
    </div>
  </div>
)

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  done: PropTypes.bool
}

export default FormGroup
